import { useHttpClient } from "@/common/api/httpClient";
import type { LogSorterResponse } from "./common/logSorterResponse";
import type { LogSorterBin } from "./common/logSorterBin";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface CreateLogSorterRequest {
  logSorter: LogSorter;
}

export interface LogSorter {
  name: string;
  intakes: string[];
  bins: LogSorterBin[];
  addLogWhenSorted: boolean;
  configuration: string;
}

export interface CreateLogSorterResponse {
  ok: true;
  logSorter: LogSorterResponse;
}

export function useCreateLogSorter() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

    return {
      execute
    };

    async function execute(action: CreateLogSorterRequest) {

      const headers = httpClient.defaultHeaders();
      const request = new Request(httpClient.siteUrl(`logsorter`), {
        headers,
        method: 'post',
        body: JSON.stringify(action.logSorter)
      });

      const text = translations.value.logSorter.actions.create;

      const response = await httpClient.action<CreateLogSorterResponse>(request, {
        title: text.title,
        errorTitle: text.error,
        async processOk(response) {
          const json = await response.json() as LogSorterResponse;

          return {
            ok: true,
            logSorter: json
          };
        },
      });

      return response;
    }
}
